<template>
  <div id="search-results" class="header-padding bg-light-grey">
    
    <div v-if="searchComplete && results.length === 0">
      <header class="page-header ff ff-ttb ff-center horizontal-padding section-padding border-bottom">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 280 360" v-bind:svg-inline="''" v-bind:title="'Warning'" v-bind:class="'svg-warning-graphic'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="#00A0C8" opacity=".4" d="M257.8 86.7l-5.3-53.5c-.6-6-6.1-9.7-11.5-8.9l4.7 47.2c.8 7.7-7 13.3-14.1 10.1l-42.3-19.1c-1.4 4.6.5 9.9 5.4 12.1l49 22.1c7.1 3.2 14.9-2.4 14.1-10z"/><path fill="none" stroke="#00A0C8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M201.4 120.5s5-35-27.7-42.3c-32.8-7.3-58.2 4.6-60.2 24.7-2 20.2-2 22.5-2 22.5"/><ellipse fill="#00A0C8" cx="119.4" cy="139.5" rx="4.2" ry="11.3"/><ellipse fill="#00A0C8" cx="146" cy="136.8" rx="4.2" ry="13.2"/><path fill="none" stroke="#00A0C8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M141.5 93.5s10.2-10.9 15.7 5.5M127.4 97.6s-6.2-6.9-10 3.2M176.2 121h35.1s0 5.5-6.9 8.2M206.5 128.6s2.6 2.7 6.1 4.1c0 0-1.6 12.1-19.6 10.5M175.5 127.6l5.9 2.6M178.4 150.6l-2.9-1.4v8.7h6.5s4.4-8.4 12.7-6.5c9.7 2.3 10.5 22.5-8.7 16.8 0 0-4.5 8.6-4.5 25.8v25.5l-21.9 24s-.1-15.9-12.4-34.2M175.5 134.9l3.4 1.6M198.1 153.2s5.5-4.6 6.2-10.8"/><path fill="none" stroke="#00A0C8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M156.5 206.3s-14.3 5.6-24.2 6.2-24.5-.1-24.5-19.7M114.1 193.8c-6.8-.7-13.6-3.8-13.6-3.8s1.4-16.9 16.4-21.7M129.4 152.3s-5.2-.4-6.5 6.1"/><path fill="none" stroke="#00A0C8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M126.5 158.3s-5.9-.8-8.9 3.7c-2.9 4.5.2 10.5 5.9 10.6 5.6.1 8.7-4.8 8.7-4.8 21 5.1 21.7 26.9 21.7 26.9-18 5.9-39.6.5-39.6.5-.4-2.4.2-5 .2-5M108.8 158.3l-.7 14.6M127.8 152c.4-2.5.2-9.9-.7-19.4 0 0-12.9-3.4-23.6 0 0 0-2.4 9.5-.7 20.6 0 0 11.5 3.5 22.2.7M160.1 132.6s-13.9-3.7-25.5 0c0 0-2.6 10.1-.7 21.9 0 0 13.2 4.1 25.2.2.1 0 2.2-9.9 1-22.1zM106.4 154.1l1.2-17.7M133.3 141.5s-2.2-1.7-5.6-.2M160.7 142.9s11.9 0 27.3 5M150.1 216.3s-6.2 7.5-10.5 27.8c0 0 6.8-8 14.1-10.2 0 0 1.6 6.9 2.1 11.4M181.5 212.4s6.8 2.5 10.5 8l-10.3 30.3s-1.6-8.6-11.4-12.1c0 0-6.1 5.3-7.8 8.6M3.1 357.1H277M191.6 222.3s4.9 2.4 6.3 5.2l-8.9 47.4-14.6 1.8M175.6 242.2s-26.4 36.4-29.6 114.6M182.6 275.8l2.5 8.9-31.4 63.1M197.9 227.5s21 4.1 26.4 15C229.6 253.4 251 356 251 356M201.5 280.1c-.2 5.3 4.5 7.3 4.5 7.3l9.1 69.5"/><path fill="none" stroke="#00A0C8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M145.3 224.7s-5.7 2.5-8.2 4.3c0 0-8.6 23.5-10.5 43.7 1.4.2 9.4 3.2 9.4 3.2M131.6 274.6l-3.4 6.2 13.6 61.5M145.7 239.1s-1.4 47.2 4.5 77.9"/><path fill="#00A0C8" d="M153.8 246.3s7.5-1.2 10.3 1.9c0 0-1.9 6.9-4.9 11.4l1.2 14.3-10.2 39s-2.9-12.8-3.4-21.2c-.5-8.4-.7-14.4-.7-14.4l7.8-18.6c.1-.1-1.2-7.3-.1-12.4z"/><path fill="none" stroke="#00A0C8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M113.8 275.5s-8.7 42.6-9.4 81.1M114.5 298.6h14.4M136.2 231.4l-63 34.7M111 288.9S64.7 313.6 60.6 315c-4 1.4-20.4 1.9-22.3-10.5C36.4 292.1 26.2 195 26.2 195l16.6-4.8M62.1 195.1s6.4 72.2 5.2 84.3"/><path fill="none" stroke="#00A0C8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M34 192.7c-2.4-11.6-5-41.1 1.2-48 6.2-6.9 20.5-11.3 20.5-11.3 5.4-2.2 6.6 4.2 7.1 16.8.5 12.6-3.1 22.6-15.3 31.4v4.5c0 12.7 19.1 13.5 19.1-.6v-85M66.7 136.7s4.9-.8 5.8 4c1 4.8-1.4 13.1-5.7 16.9M47.5 100.5v35.9M50.4 100.2h-2.7c-2.1 0-3.8-1.7-3.8-3.8v0c0-2.1 1.7-3.8 3.8-3.8h18.5c2.1 0 3.8 1.7 3.8 3.8v0c0 2.1-1.7 3.8-3.8 3.8H55.5M66.3 123.1H55.4M47.5 123.1h2.7"/><path fill="#00A0C8" opacity=".4" d="M50.4 123.1v12c2.8-1.4 8-3.6 9.3-1.4 1.7 3 4.3 15.6 2.4 25-1.8 8.7-3.2 12.9-11.6 20.4v7.1c0 3.6 2.9 6.5 6.5 6.5s6.5-2.9 6.5-6.5v-63.1H50.4z"/><path fill="none" opacity=".4" stroke="#00A0C8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M52 106.2v11.4"/><path fill="#00A0C8" opacity=".4" d="M118.3 122.2c-1.4.6-2.5-.5-2.3-2.3.9-7.1 3.4-15.4 7-17 3-1.4 4.2 8.3 4.6 14.4.1 2-1.4 4.1-2.9 3.9-1.8-.2-4-.1-6.4 1zM175.6 121h25.8s3.5-28.9-15.5-37.9c-20.8-9.9-32.2 5.8-35.8 14.2-.7 1.7-2.7 2.6-4.5 1.9-.5-.2-1.1-.4-1.5-.4-4.5-.2-6.1 10.8-6.7 17.5-.2 2.2 2.1 3.8 4.3 3 .9-.3 2.4-.6 3.9-.8 3.3-.5 6.2 1.5 7.5 4.5 1.5 3.3 3 6.1 2.7 13.7-.4 12.4-4 18.2-6.1 29.5-2 11.3-.5 13.6-.5 13.6s4.2 8.9 4.6 14.4c-4.4 1.7-20.3 6.8-39.6.7l-2-1.5-4.6-.8s-.3 2.5 0 3.7c0 0 13.5 9 38.3 4.1-3.8 4.1-10.6 9.7-20.7 11.9 0 0 10.8 1.3 21.9-3l4.9 8.4s7.9-5.9 12-6.3c4-.4 9.1 12.6 6.5 20.1l10.9-12s.1-16.2.1-29.3c0-13.1 2.7-21.5 4.4-22.1 0 0 11.5 5.4 14.7-3.9 3.2-9.3-5.1-14.7-11.9-12.6-6.8 2.1-6.8 6.1-6.8 6.1h-6.5V149l-1.5-2.3c-.7-1.1.2-2.5 1.5-2.3l-3.1-8.3c-.5-1.2.8-2.4 1.9-1.9l2.9 1.2-3.6-6c-.7-1.2.5-2.6 1.8-2.1l1.8.7-2.9-5.2c-.4-.6.3-1.8 1.4-1.8z"/><path fill="#00A0C8" opacity=".4" d="M121.5 168.3s.8 4.2 5 4.2 6.6-4.8 6.6-4.8l2.8 1.1s.1-6.8-2.9-8.8l.8-8.9v-5.9s-3 2.3-4.4 7.3c0 0-1.7 1.3-3.5 5.8.1.1-5.4 1.7-4.4 10zM109.5 129.6l18.9 16.4s.5-12.1-.9-15.2c0 0-7.2-2.5-18-1.2zM102.2 143l10.9 11.9s-8.6 0-10.3-1.8l-.6-10.1z"/><path fill="#00A0C8" opacity=".4" d="M133.4 149.2l8.1 6.8 8.3.3-16.4-13.5zM141.8 241.8s7.5-22.6 11-22.8c0 0 6.7 13.8 6.8 22.8l.9.9 21-23.1s-2-8.8 2.1-6.2c4.1 2.5 8.5 7.1 8.5 7.1l-10.3 30.3s-5.1-10.8-7-7.1c-1.9 3.7-14.7 32.3-14.7 32.3l-13.7 1.4-1.5-38.1-3.1 2.5zM36.8 192l11.1-3.3-.3-7.2s10-6.6 13.7-19.2 1.6-22.5 0-25.6c-1.6-3.1-17.7 4.8-22.9 15.5-5.2 10.7-1.6 39.8-1.6 39.8zM66.7 136.7s7.4.3 5.9 8.5c-1.5 8.3-6.2 13.6-6.2 13.6l.3-22.1zM215 233.8l28.9 122.8 7.1-.5s-24.1-107.8-26.7-113.5c-4-8.8-9.3-8.8-9.3-8.8zM215 357.7l-9.1-70.3s-3.5-1.3-4.3-5.2l2.7 74.9 10.7.6zM201.7 228.5s-3.7-1.4-3.9 0c-.3 1.4-8.7 46.5-8.7 46.5l-6.4.9 2.5 8.9-30.4 61.2 35.6-57.9s-2.1-7.3-1.1-7.9 6.4-2 6.4-2l6-49.7zM122.8 299.4s-5.5 23-1.1 22.5 6.3-22.5 6.3-22.5h-5.2zM113.4 277.3c.5-3.5-50.7 38.5-67 37 0 0 8.9 3.6 18.7-1.4 9.8-5 44.6-23.4 44.6-23.4s1.4 4.1 3.7-12.2z"/><path fill="#00A0C8" d="M249.4 75.3l-5.3-53.5c-.8-7.7-9.5-11.6-15.8-7.1L184.7 46c-6.2 4.5-5.3 14.1 1.7 17.2l49 22.1c7 3.2 14.8-2.4 14-10zm-23.5-44.7c.7-1.6 2.7-2.4 4.3-1.6l2 .9c1.6.7 2.4 2.7 1.6 4.3l-2 4.4c0 .1-.1.2-.1.2l-6.6 11.9c-.8 1.5-2.6 2.1-4.2 1.4-1.5-.7-2.3-2.5-1.7-4.1l4.6-12.8c0-.1.1-.2.1-.2l2-4.4zm-10.7 34.3c-2.8-1.3-3.9-4.3-2.7-6.9 1.2-2.6 4.2-3.8 7-2.5 2.7 1.2 3.9 4.3 2.7 6.9-1.3 2.6-4.3 3.8-7 2.5zM76.4 11.4c-1.1-3.2.7-6.7 4-7.8l4-1.3c3.2-1.1 6.7.7 7.8 4l2.8 8.6c.1.2.1.3.1.5l5.9 25c.7 3.1-1 6.3-4.1 7.3-3.1 1-6.4-.5-7.6-3.5l-9.9-23.7c-.1-.2-.1-.3-.2-.5l-2.8-8.6zM105.2 73.1c-5.5 1.8-11-1-12.7-6.2-1.7-5.2 1.1-10.7 6.6-12.5 5.4-1.8 10.9 1 12.6 6.2 1.7 5.3-1.1 10.7-6.5 12.5z"/><g fill="#00A0C8"><path opacity=".4" d="M83.2 10.7c-.8-3.3 1.3-6.7 4.6-7.5l4.1-1c3.3-.8 6.7 1.3 7.5 4.6l2.1 8.9c0 .2.1.3.1.5l4 25.7c.5 3.2-1.6 6.3-4.7 7-3.2.8-6.4-1-7.4-4.1l-8.1-24.7c-.1-.2-.1-.3-.1-.5l-2.1-8.9zM107.2 75.1c-5.7 1.4-11-1.9-12.3-7.3-1.3-5.4 2-10.7 7.6-12 5.6-1.3 10.9 1.9 12.2 7.3 1.4 5.4-1.9 10.7-7.5 12z"/></g><path fill="none" opacity=".4" stroke="#00A0C8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" d="M120.1 9c-.2-2.1 1.4-3.9 3.5-4.1l2.6-.2c2.1-.2 3.9 1.4 4.1 3.5l.4 5.6v.3l-.1 15.8c0 2-1.5 3.6-3.5 3.7-2 .1-3.7-1.2-4-3.2l-2.4-15.6v-.3l-.6-5.5zM128.2 49.9c-3.5.3-6.4-2.2-6.6-5.5-.2-3.3 2.2-6.2 5.8-6.5 3.5-.3 6.3 2.2 6.6 5.6.2 3.3-2.3 6.2-5.8 6.4z"/></svg>
        <h1>No Results</h1>
        <div class="max-width-700">
          <p v-if="suggestions.length > 0">Sorry, but we didn’t find any items that matched your query.<br>
            Did you mean <strong v-on:click="trySuggestion(suggestions[0].suggestion)"><em>{{ suggestions[0].suggestion }}</em></strong>?</p>
          <p v-else>Sorry, but we didn’t find any items matching your query.<br>
            Try different (more general) keywords. Or, <router-link to="/contact-us">contact us</router-link> with your enquiry.</p>
        </div>
      </header>
      
      <section id="recommendations" class="ff ff-ttb ff-center horizontal-padding section-padding bg-light-grey">
        <div class="content-block">
          <h2 class="section-heading cyan">Recommended Pages</h2>
          
          <div class="content-type-text large max-width-900">
            <p class="large">Not sure what you’re looking for? See links to commonly requested information below:</p>
            <hr class="hr-100">
          </div>
          
          <div class="content-type-tiles max-width">
            <div class="ff-columns">
              <article 
                id="recomendation-tests"
                class="ff ff-text-center ff-12 ff-sm-6 ff-lg-4 animated-tile" 
                data-aos="fade-up"
                data-aos-once="true"
                data-aos-duration="250"
                data-aos-delay="0"
              >
                <router-link to="/tests" class="bg-white ff-12 tile">
                  <div class="column-image column-image-icon"></div>
                  
                  <div class="padding min-padding no-padding-top">
                    <h4 class="tile-heading">Tests and Pricing</h4>
                    <hr class="hr-50">
                    <div>
                      <p>View our tests, methods and pricing, all in one place.</p>
                    </div>
                  </div>
                </router-link>
              </article>
              
              <article 
                id="recomendation-faq"
                class="ff ff-text-center ff-12 ff-sm-6 ff-lg-4 animated-tile" 
                data-aos="fade-up"
                data-aos-once="true"
                data-aos-duration="250"
                data-aos-delay="100"
              >
                <router-link to="/faq" class="bg-white ff-12 tile">
                  <div class="column-image column-image-icon"></div>
                  
                  <div class="padding min-padding no-padding-top">
                    <h4 class="tile-heading">Frequently Asked Questions</h4>
                    <hr class="hr-50">
                    <div>
                      <p>View our FAQ, for commonly asked questions.</p>
                    </div>
                  </div>
                </router-link>
              </article>
              
              <article 
                id="recomendation-our-lab"
                class="ff ff-text-center ff-12 ff-sm-6 ff-lg-4 animated-tile" 
                data-aos="fade-up"
                data-aos-once="true"
                data-aos-duration="250"
                data-aos-delay="200"
              >
                <router-link to="/our-lab" class="bg-white ff-12 tile">
                  <div class="column-image column-image-icon"></div>
                  
                  <div class="padding min-padding no-padding-top">
                    <h4 class="tile-heading">Our Lab</h4>
                    <hr class="hr-50">
                    <div>
                      <p>Learn more about our highly skilled team, automated processes, robust methods and equipment.</p>
                    </div>
                  </div>
                </router-link>
              </article>
            </div>
          </div>
        </div>
      </section>
    </div>
    
    <div v-else>
      <header class="page-header ff ff-center horizontal-padding section-padding">
        <h1>Search Results</h1>
        <p v-if="q && results.length > 0" class="large"><em class="search-results-query">{{ q }}</em> has provided <strong><em>{{ searchTotal }}</em></strong>.</p>
      </header>
      

      <aside id="sort-filters" class="horizontal-padding">
        <div class="max-width">
          
          <transition name="toggle-filters" duration=800>
            <div v-if="showFilters" id="search-filters">
              <div class="border border-grey">
                <form id="search-filters-form" class="standard ff-text-left" @submit.prevent="runSearch" method="post">
                  
                  <div class="padding">
                    <div class="ff-columns ff-align-center ff-text-left">
                      
                      <div class="form-block-radio-vertical ff-6 ff-md-3 ff-lg-auto">
                        <label class="label">Search in:</label>
                        
                        <div class="form-block-radio">
                          <input 
                            v-model="searchType" 
                            type="radio" 
                            id="type-everything" 
                            value="Tests and FAQ"
                          >
                          <label for="type-everything">
                            <span class="radio-tick"><icon name="ui-tick" color="cyan" /></span>
                            <span>Tests and FAQ</span>
                          </label>
                        </div>
                        
                        <div class="form-block-radio">
                          <input 
                            v-model="searchType" 
                            type="radio" 
                            id="type-faq" 
                            value="FAQ"
                          >
                          <label for="type-faq">
                            <span class="radio-tick"><icon name="ui-tick" color="cyan" /></span>
                            <span>FAQ</span>
                          </label>
                        </div>
                        
                        <div class="form-block-radio">
                          <input 
                            v-model="searchType" 
                            type="radio" 
                            id="type-tests" 
                            value="Tests"
                          >
                          <label for="type-tests">
                            <span class="radio-tick"><icon name="ui-tick" color="cyan" /></span>
                            <span>Tests</span>
                          </label>
                        </div>
                      </div>
                      
                      <div class="form-block-radio-vertical ff-6 ff-md-3 ff-lg-auto">
                        <label class="label">Match:</label>
                        
                        <div class="form-block-radio">
                          <input 
                            v-model="searchCriteria" 
                            type="radio" 
                            id="criteria-any" 
                            value="any"
                          >
                          <label for="criteria-any">
                            <span class="radio-tick"><icon name="ui-tick" color="cyan" /></span>
                            <span>Any word</span>
                          </label>
                        </div>
                        
                        <div class="form-block-radio">
                          <input 
                            v-model="searchCriteria" 
                            type="radio" 
                            id="criteria-all" 
                            value="all"
                          >
                          <label for="criteria-all">
                            <span class="radio-tick"><icon name="ui-tick" color="cyan" /></span>
                            <span>All words</span>
                          </label>
                        </div>
                        
                        <div class="form-block-radio">
                          <input 
                            v-model="searchCriteria" 
                            type="radio" 
                            id="criteria-exact" 
                            value="exact"
                          >
                          <label for="criteria-exact">
                            <span class="radio-tick"><icon name="ui-tick" color="cyan" /></span>
                            <span>Exact phrase</span>
                          </label>
                        </div>
                      </div>
                      
                      <div class="form-block-group ff-12 ff-md-6 ff-lg-5 ff-xl-8">
                        <div class="ff-columns">
                          <div class="form-block-sample-type ff-12 ff-xl-6">
                            <label class="label">Sample Type:</label>
                            
                            <div class="form-block-select">
                              <select 
                                v-if="sampleTypes.length > 0"
                                v-model="sampleType" 
                                id="sample-type"
                              >
                                <option value="">Any</option>
                                <option v-for="(sType,s) in sampleTypes" :value="sType.name" :key="'filter-fc-'+sType.slug+'-'+s">
                                  {{ sType.name }}
                                </option>
                              </select>
                              
                              <select 
                                v-else
                                v-model="sampleType" 
                                id="sample-type"
                              >
                                <option v-if="sampleType" :value="sampleType">{{ sampleType }}</option>
                                <option v-else value="">Any</option>
                              </select>
                              
                              <div class="select-arrow">
                                <icon name="ui-chevron-down" color="black" size=18 />
                              </div>
                            </div>
                          </div>
                          
                          <div class="form-block-faq-category ff-12 ff-xl-6">
                            <label class="label">Category:</label>
                            
                            <div class="form-block-select">
                              <select 
                                v-if="faqCategories.list.length > 0"
                                v-model="faqCategory" 
                                id="faq-categories"
                              >
                                <option value="">Any</option>
                                <option v-for="(faqCat,fc) in faqCategories.list" :value="faqCat.name" :key="'filter-fc-'+faqCat.slug+'-'+fc">
                                  {{ faqCat.name }}
                                </option>
                              </select>
                              
                              <select 
                                v-else
                                v-model="faqCategory" 
                                id="faq-categories"
                              >
                                <option v-if="faqCategory" :value="faqCategory">{{ faqCategory }}</option>
                                <option v-else value="">Any</option>
                              </select>
                              
                              <div class="select-arrow">
                                <icon name="ui-chevron-down" color="black" size=18 />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                    </div>
                  </div>
                  
                  <div class="form-block-search-apply-filters ff ff-12 ff-center padding border-top-thin border-grey">
                    <button role="submit" type="submit" class="btn bg-cyan ff ff-auto" @click="applyFilters">
                      <span>Apply Filters</span>
                      <icon name="ui-chevron-right" color="white" />
                    </button>
                    <button role="reset" type="reset" class="btn bg-grey ff ff-auto" @click.prevent="clearFilters">
                      <icon name="ui-cross" color="white" />
                      <span>Clear Filters</span>
                    </button>
                  </div>
                  
                </form>
              </div>
              <div class="close-search-filters ff ff-center" v-on:click="toggleFilters">
                <icon name="ui-cross" color="white" size=18 />
              </div>
            </div>
          </transition>
          
          <ul class="sort-filters ff ff-md-nowrap ff-align-between ff-valign-center grey">
            <li class="sort-filter-type ff ff-center ff-xl-align-left" v-on:click="setSortOrder('data_type')">
              <h5 class="ff-mobile-hide ff-lg-hide">Type</h5>
              <div class="sort-arrows ff ff-ttb">
                <div class="asc" :class="resultsSortBy === 'data_type' && resultsSortAsc ? 'active' : ''">
                  <icon name="ui-chevron-up" color="grey" size=12 />
                </div>
                <div class="desc" :class="resultsSortBy === 'data_type' && !resultsSortAsc ? 'active' : ''">
                  <icon name="ui-chevron-down" color="grey" size=12 />
                </div>
              </div>
            </li>
            
            <li class="sort-filter-heading ff ff-valign-center" v-on:click="setSortOrder('name')">
              <h5>Heading</h5>
              <div class="sort-arrows ff ff-ttb">
                <div class="asc" :class="resultsSortBy === 'name' && resultsSortAsc ? 'active' : ''">
                  <icon name="ui-chevron-up" color="grey" size=12 />
                </div>
                <div class="desc" :class="resultsSortBy === 'name' && !resultsSortAsc ? 'active' : ''">
                  <icon name="ui-chevron-down" color="grey" size=12 />
                </div>
              </div>
            </li>
            
            <li class="sort-filter-category ff ff-valign-center ff-mobile-hide" v-on:click="setSortOrder('category')">
              <h5>Category</h5>
              <div class="sort-arrows ff ff-ttb">
                <div class="asc" :class="resultsSortBy === 'category' && resultsSortAsc ? 'active' : ''">
                  <icon name="ui-chevron-up" color="grey" size=12 />
                </div>
                <div class="desc" :class="resultsSortBy === 'category' && !resultsSortAsc ? 'active' : ''">
                  <icon name="ui-chevron-down" color="grey" size=12 />
                </div>
              </div>
            </li>
            
            <li class="sort-filter-description ff ff-fill ff-valign-center ff-mobile-hide" v-on:click="setSortOrder('description')">
              <h5>Description</h5>
              <div class="sort-arrows ff ff-ttb">
                <div class="asc" :class="resultsSortBy === 'description' && resultsSortAsc ? 'active' : ''">
                  <icon name="ui-chevron-up" color="grey" size=12 />
                </div>
                <div class="desc" :class="resultsSortBy === 'description' && !resultsSortAsc ? 'active' : ''">
                  <icon name="ui-chevron-down" color="grey" size=12 />
                </div>
              </div>
            </li>
            
            <li class="sort-filter-toggle ff ff-auto ff-valign-center" v-on:click="toggleFilters">
              <div class="btn bg-cyan white ff ff-valign-center">
                <icon name="icon-filter" color="white" />
                <span>Filters</span>
              </div>
            </li>
          </ul>
        </div>
      </aside>
        
      <section id="results" class="horizontal-padding section-padding">
        <transition-group name="fade-list" tag="div" class="max-width">
          <article v-for="result in results" class="results-item" :key="result.data_type + '-' + result.category_slug + '-' + result.id">
            <router-link :to="result.url" class="ff ff-nowrap ff-align-between">
              <div class="results-item-type ff ff-center">
                <icon :name="'icon-' + result.icon" color="cyan" size=34 />
              </div>
              
              <div class="results-details ff ff-fill ff-lg-nowrap ff-align-between">
                <div class="results-item-heading ff ff-valign-center black">
                  <strong>{{ result.name | truncateName }}</strong>
                </div>
                
                <div class="results-item-category ff ff-nowrap ff-valign-center ff-mobile-hide">
                  <icon :name="'icon-' + result.category_icon" color="grey" size=18 />
                  <h3 class="grey ff-text-left">{{ result.category }}</h3>
                </div>
                
                <div class="results-item-description ff ff-12 ff-lg-fill ff-valign-center grey">
                  <div v-if="result.description">{{ result.description | truncateDesc }}</div>
                  <div v-else></div>
                </div>
                
                <div class="results-item-arrow ff ff-auto ff-valign-center ff-mobile-hide ff-lg-hide">
                  <div class="results-item-circle ff ff-center bg-grey">
                    <icon name="ui-chevron-right" color="white" size=18 />
                  </div>
                </div>
              </div>
            </router-link>
          </article>
        </transition-group>  
      </section>
      
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  export default {
    name: "searchResults",
    data() {
      return {
        searchComplete: false,
        showFilters: false,
        suggestions: [],
        faqCategories: {
          loading: false,
          list: []
        },
        results: []
      }
    },
    computed: {
      apiURL() {
        return this.$store.state.apiURL;
      },
      searchTotal() {
        var total = this.$store.state.search.total;
        var totalOutput = '0 search results';
        
        if(total){
          if (total == 1) {
            totalOutput = total + ' search result';
          } else {
            totalOutput = total + ' search results';
          }
        }
        
        return totalOutput;
      },
      sampleTypes() {
        var sampleTypes = [];
        var sTypes = this.$store.getters.sampleTypes;
        
        sTypes.forEach(function(sType){
          
          if(sType.sub_categories){
            
            sType.sub_categories.forEach(function(subType){
              sampleTypes.push(subType);
            });
            
          } else {
            sampleTypes.push(sType);
          }
          
        });
        
        return sampleTypes;
      },
      q() {
        var q = this.$store.state.search.query;
        return q;
      },
      isSearching() {
        var isSearching = this.$store.state.search.isSearching;
        return isSearching;
      },
      resultsSortBy() {
        var resultsSortBy = this.$store.state.search.sort.by;
        return resultsSortBy;
      },
      resultsSortAsc() {
        var resultsSortAsc = this.$store.state.search.sort.asc;
        return resultsSortAsc;
      },
      searchType: {
        get () {
          return this.$store.state.search.type;
        },
        set (value) {
          switch(value) {
            case 'FAQ':
              this.$store.commit('setSearch', { key: 'sampleType' , val: '' });
              break;
            case 'Tests':
              this.$store.commit('setSearch', { key: 'faqCategory' , val: '' });
              break;
            }
          
          this.$store.commit('setSearch', { key: 'type' , val: value });
        }
      },
      searchCriteria: {
        get () {
          return this.$store.state.search.criteria;
        },
        set (value) {
          this.$store.commit('setSearch', { key: 'criteria' , val: value });
        }
      },
      faqCategory: {
        get () {
          return this.$store.state.search.faqCategory;
        },
        set (value) {
          this.$store.commit('setSearch', { key: 'faqCategory' , val: value });
        }
      },
      sampleType: {
        get () {
          return this.$store.state.search.sampleType;
        },
        set (value) {
          this.$store.commit('setSearch', { key: 'sampleType' , val: value });
        }
      },
      meta() {
        var meta = {
          title: "Search",
          url: "https://www.csbplab.com.au/search",
          desc: "",
          image: ""
        }
        
        return meta;
      }
    },
    beforeMount() {
      this.loadCategories();
      this.runSearch();
    },
    methods: {
      async runSearch() {
        // Set the search query
        const searchParams = new URLSearchParams();
        searchParams.append('q', this.q);
        searchParams.append('p', this.searchCriteria);
        
        if(this.sampleType) {
          searchParams.append('s', this.sampleType);
        }
        
        if(this.faqCategory) {
          searchParams.append('c', this.faqCategory);
        }
        
        // Set the search API url
        let searchURL = 'search';
        
        if(this.searchType === 'FAQ') {
          searchURL = 'search/faq';
        } else if(this.searchType === 'Tests') {
          searchURL = 'search/tests';
        } else {
          searchURL = 'search';
        }
        
        // Request data from API
        await this.$axios.get(this.apiURL+searchURL, { params: searchParams }). then((response) => {
          var sortBy = this.$store.state.search.sort.by;
          
          if(response.data.results !== undefined) {
            if(sortBy === 'default'){
              this.results = response.data.results;
            } else {
              this.results = this.sortResults(response.data.results);
            }
            
            this.suggestions = [];
            this.$store.commit('setSearch', { key: 'total' , val: response.data.results.length });
          }
          
          if(response.data.suggestions !== undefined) {
            this.suggestions = response.data.suggestions;
            this.results = [];
            this.$store.commit('setSearch', { key: 'total' , val: 0 });
          }
          
        // eslint-disable-next-line
        }, (error)  =>  {
          // eslint-disable-next-line
          console.log('Search error.');
        });
        
        this.$store.commit('setSearch', { key: 'isSearching' , val: false });
        this.searchComplete = true;
        
      },
      async loadCategories() {
      // Start loading
        this.faqCategories.loading = true;
        
        // Request data from API
        await this.$axios.get(this.apiURL+"faq/categories"). then((response) => {
          this.faqCategories.list = response.data.categories;
        // eslint-disable-next-line
        }, (error)  =>  {
          // Errors here
        });
        
        // Finish loading
        this.faqCategories.loading = false;
        
      },
      setSortOrder(sortBy) {
        var currentSort = this.$store.state.search.sort.by;
        var sortAsc = this.$store.state.search.sort.asc;
        
        // if sortBy is the same as current sortBy then reverse the direction
        if(currentSort === sortBy) {
          sortAsc = !sortAsc;
        }
        
        this.$store.commit('setSearch', { key: 'sort' , val: {
          by: sortBy,
          asc: sortAsc
        } });
        
        // sort the results
        this.results = this.sortResults(this.results);
      },
      sortResults(results){
        var sortBy = this.$store.state.search.sort.by;
        var sortAsc = this.$store.state.search.sort.asc;
        var sorted = [];
        
        if(sortAsc) {
          // If ASC
          sorted = results.sort((a, b) => (a[sortBy] > b[sortBy]) ? 1 : -1);
        } else {
          // If DESC
          sorted = results.sort((a, b) => (a[sortBy] < b[sortBy]) ? 1 : -1);
        }
        
        return sorted;
        
      },
      trySuggestion(value) {
        this.$store.commit('setSearch', { key: 'query' , val: value });
        
        if(this.q.length > 2) {
          this.runSearch();
        }
      },
      toggleFilters() {
        this.showFilters = !this.showFilters;
        
        if(this.showFilters === true) {
          this.$gtm.trackEvent({
            'event': 'search',
            'action': 'click',
            'button-name': 'filters'
          });
        }
      },
      applyFilters() {
        this.$gtm.trackEvent({
          'event': 'search',
          'action': 'click',
          'category': this.faqCategory,
          'button-name': 'apply filters',
          'search-in': this.searchType,
          'match': this.searchCriteria,
          'sample-type': this.sampleType
        });
      },
      clearFilters() {
        // Clear all values
        this.searchType = 'Tests and FAQ';
        this.searchCriteria = 'any';
        this.faqCategory = '';
        this.sampleType = '';
        
        this.$gtm.trackEvent({
          'event': 'search',
          'action': 'click',
          'button-name': 'clear filters'
        });
        
        // Then rerun the search query
        this.runSearch();
      }
    },
    filters: {
      truncateName(val) {
        var str = document.createElement('textarea');
        
        if (val.length > 80) {
          str.innerHTML = val.substring(0, 80) + '...';
        } else {
          str.innerHTML = val;
        }
        
        return str.value;
      },
      truncateCat(val) {
        var str = '';
        
        if (val.length > 20) {
          str = val.substring(0, 20) + '...';
        } else {
          str = val;
        }
        
        return str;
      },
      truncateDesc(val) {
        var str = document.createElement('textarea');
        
        if (val) {
          
          if (val.length > 160) {
            str.innerHTML = val.substring(0, 160) + '...';
          } else {
            str.innerHTML = val;
          }
          
          return str.value;
          
        } else {
          
          return val;
          
        }
      }
    },
    watch:{
      // eslint-disable-next-line
      isSearching() {
        if(this.isSearching === true) {
          this.runSearch();
        }
      }
    },
    metaInfo () {
      return {
        title: this.meta.title,
        link: [
          {
            rel: "canonical",
            href: this.meta.url
          }
        ],
        meta: [
          {
            name: "description",
            content: this.meta.desc
          },
          {
            property: "og:title",
            content: this.meta.title + " | CSBP Lab"
          },
          {
            property: "og:url",
            content: this.meta.url
          },
          {
            property: "og:image",
            content: this.meta.image
          },
          {
            property: "og:description",
            content: this.meta.desc
          },
          {
            property: "twitter:title",
            content: this.meta.title + " | CSBP Lab"
          },
          {
            property: "twitter:site",
            content: this.meta.url
          },
          {
            property: "twitter:image.src",
            content: this.meta.image
          },
          {
            property: "twitter:description",
            content: this.meta.desc
          }
        ]
      }
    }
  }
</script>